import type { VentaActividad } from '../lib/supabase';
import type { CambiosVentaActividad } from '../services/ventaActividadService';

interface FormularioEdicionPedido {
  readonly producto_id: string;
  readonly produccion_id: string;
  readonly cantidad: number;
  readonly precio_unitario: number;
  readonly fecha_venta: string;
  readonly forma_entrega: 'retiro' | 'despacho';
  readonly fecha_entrega: string;
  readonly direccion_despacho: string;
  readonly rango_horario_retiro_despacho: string;
  readonly notas: string;
}

/** El lote vacío es NULL explícito: omitirlo conservaría el vínculo anterior. */
export function prepararCambiosPedidoActividad(formulario: FormularioEdicionPedido,
  cliente: Pick<CambiosVentaActividad, 'miembro_id' | 'nombre_externo' | 'miembro_referido_id'>,
): CambiosVentaActividad {
  return {
    ...cliente, producto_id: formulario.producto_id || null, produccion_id: formulario.produccion_id || null,
    cantidad: formulario.cantidad, monto_total: formulario.cantidad * formulario.precio_unitario,
    fecha_venta: formulario.fecha_venta, forma_entrega: formulario.forma_entrega,
    fecha_entrega: formulario.fecha_entrega || null,
    direccion_despacho: formulario.forma_entrega === 'despacho' ? formulario.direccion_despacho : null,
    rango_horario_retiro_despacho: formulario.rango_horario_retiro_despacho || null,
    notas: formulario.notas || null,
  };
}

/** Solo la reserva del mismo destino puede restituirse al validar una edición. */
export function stockDisponiblePedidoActividad(stockDisponible: number, productoId: string,
  produccionId: string | null, anterior?: Pick<VentaActividad, 'producto_id' | 'produccion_id' | 'cantidad'>,
): number {
  const mismoProducto = !!anterior?.producto_id && anterior.producto_id === productoId;
  const mismoLote = (anterior?.produccion_id || null) === produccionId;
  return stockDisponible + (mismoProducto && mismoLote ? anterior?.cantidad ?? 0 : 0);
}

export function validarStockLotePedidoActividad(cantidad: number, productoId: string, produccionId: string,
  lote: { readonly producto_id?: string; readonly nombre: string; readonly stock_disponible: number } | undefined,
  anterior?: Pick<VentaActividad, 'producto_id' | 'produccion_id' | 'cantidad'>,
): string | null {
  if (!lote) return 'El lote seleccionado no está disponible.';
  if (lote.producto_id !== productoId) return 'El lote seleccionado no pertenece al producto.';
  const disponible = stockDisponiblePedidoActividad(lote.stock_disponible, productoId, produccionId, anterior);
  return cantidad > disponible ? `Stock insuficiente en ${lote.nombre}. Disponible: ${disponible} unidades` : null;
}

/** Navegar no edita fechas elegidas ni hace que una entrega real siga a la venta. */
export function fechasAlAvanzarPedidoActividad<T extends { readonly fecha_venta: string; readonly fecha_entrega: string }>(
  formulario: T, esEdicion: boolean,
): T {
  return !esEdicion && !formulario.fecha_entrega
    ? { ...formulario, fecha_entrega: formulario.fecha_venta } : formulario;
}
